import { render, staticRenderFns } from "./report_stu_after.vue?vue&type=template&id=1427b89d&scoped=true&"
import script from "./report_stu_after.vue?vue&type=script&lang=js&"
export * from "./report_stu_after.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_after.vue?vue&type=style&index=0&id=1427b89d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427b89d",
  null
  
)

export default component.exports